import { render, staticRenderFns } from "./invoice-info.vue?vue&type=template&id=43668107&scoped=true"
import script from "./invoice-info.vue?vue&type=script&lang=ts"
export * from "./invoice-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43668107",
  null
  
)

export default component.exports